import type { Domain, Project } from "store/appData";

export function domainBaseUrl(domain: Domain): string {
  const trimmed = domain.url.replace(/\/+$/, "");
  return /^https?:\/\//.test(trimmed) ? trimmed : `https://${trimmed}`;
}

export function projectDomain(
  project: Pick<Project, "primary_domain_id">,
  domains: Record<number, Domain>
): Domain | null {
  if (!project.primary_domain_id) return null;
  return domains[project.primary_domain_id] ?? null;
}
